import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2234a39c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "items-in-line" }

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination, Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { computed, getCurrentInstance, onMounted, ref, Ref, watch } from 'vue';
import { useAppStore } from '@/store/modules/app';
import { ComponentInternalInstance } from '@vue/runtime-core';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSwiper',
  props: {
    slides: {},
    widthItem: { default: 120 },
    itemsToShow: {},
    spaceBetween: { default: 14 }
  },
  emits: ['swiper'],
  setup(__props: any, { emit: __emit }) {

const modules = [Pagination, Navigation, Thumbs];

const props = __props;
const emit = __emit;
const window = computed((): number => {
  return useAppStore().window;
});
const instance: ComponentInternalInstance | null = getCurrentInstance();
const uuid = ref(instance?.uid);
const galleryWidth: Ref<number | undefined> = ref(undefined);
const maxItemsToShow: Ref<number> = ref(1);
const prev = ref(null);
const next = ref(null);
const updateGalleryWidth = () => {
  if (props.slides?.length > 1) {
    const thumbnails = document.getElementById(`swiper${uuid.value}`);

    galleryWidth.value = thumbnails?.offsetWidth;
    updateMaxItemsToShow();
  }
};

const updateMaxItemsToShow = () => {
  if (galleryWidth.value) {
    maxItemsToShow.value =
      (galleryWidth.value - 60) / (props.widthItem + props.spaceBetween);
  } else {
    updateGalleryWidth();
  }
};

onMounted(() => {
  if (props.itemsToShow) {
    maxItemsToShow.value = props.itemsToShow;
  } else {
    updateGalleryWidth();
  }
});
watch(
  () => window.value,
  () => {
    if (!props.itemsToShow) {
      updateGalleryWidth();
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "prev",
      ref: prev,
      class: "swiper-button-prev"
    }, null, 512),
    _createVNode(_unref(Swiper), {
      id: `swiper${uuid.value}`,
      modules: modules,
      navigation: {
        prevEl: prev.value,
        nextEl: next.value,
      },
      "slides-per-group": maxItemsToShow.value,
      "slides-per-view": maxItemsToShow.value,
      "space-between": _ctx.spaceBetween,
      class: "swiper",
      onSwiper: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('swiper')))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide, i) => {
          return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: i }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "item", { data: slide })
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 3
    }, 8, ["id", "navigation", "slides-per-group", "slides-per-view", "space-between"]),
    _createElementVNode("div", {
      ref_key: "next",
      ref: next,
      class: "swiper-button-next"
    }, null, 512)
  ]))
}
}

})